import { useCallback } from 'react';

import { useApolloClient } from '@apollo/client';

import getReservableBookings from 'lane-shared/graphql/query/getReservableBookings';

import { ReservableBookingItem } from './useGetReservableBookings';

interface QueryResponse {
  reservableBookings: {
    items: ReservableBookingItem[];
  };
}

/**
 * Fetches a single booking by its interaction id, used to refresh one row after
 * its status changes instead of re-fetching the whole page.
 */
export function useGetReservableBooking({ channelId }: { channelId: string }) {
  const client = useApolloClient();

  const fetchBooking = useCallback(
    async (interactionId: string): Promise<ReservableBookingItem | null> => {
      const { data } = await client.query<QueryResponse>({
        query: getReservableBookings,
        fetchPolicy: 'network-only',
        variables: {
          search: { channelId, id: interactionId },
          pagination: { start: 0, perPage: 1 },
        },
      });

      return data?.reservableBookings?.items?.[0] ?? null;
    },
    [client, channelId]
  );

  return { fetchBooking };
}
